import * as FirstPartyFetchResponse from "../../../domain/models/FirstPartyFetchResponse";
import * as UserSuccessResponse2 from "../../../domain/models/UserSuccessResponse2";

export class C {
    public userResponse: FirstPartyFetchResponse.T<UserSuccessResponse2.T> = FirstPartyFetchResponse.createNotRequested(UserSuccessResponse2.newDefault());
}
